import Raven from 'raven-js';
import { Component } from 'react';
import { UIAUMetrics } from './_core/utils/metricUtils';

// props passed in when withErrorBoundary is called
import { jsx as _jsx } from "react/jsx-runtime";
export class ErrorBoundary extends Component {
  constructor(...args) {
    super(...args);
    this.state = {
      hasError: false
    };
  }
  static getDerivedStateFromError() {
    return {
      hasError: true
    };
  }
  componentDidCatch(error, info) {
    Raven.captureException(new Error('Error boundary caught uncaught exception', {
      cause: error
    }), {
      extra: {
        message: error.message,
        boundaryName: this.props.boundaryName,
        info
      },
      fingerprint: [`uiau-error-boundary-${this.props.boundaryName}`]
    });
    UIAUMetrics.counter('error-boundary-triggered', {
      boundaryName: this.props.boundaryName
    }).increment();
  }
  render() {
    if (this.state.hasError) {
      const {
        boundaryName
      } = this.props;
      console.error('ErrorBoundary caught uncaught error', boundaryName);
      return null;
    }
    return this.props.children;
  }
}
function withErrorBoundary(WrappedComponent, errorBoundaryProps) {
  const ErrorBoundaryWrapper = props => /*#__PURE__*/_jsx(ErrorBoundary, Object.assign({}, errorBoundaryProps, {
    children: /*#__PURE__*/_jsx(WrappedComponent, Object.assign({}, props))
  }));
  return ErrorBoundaryWrapper;
}
export default withErrorBoundary;